const MaskedInput = (ariaLabel: string) => {
  return <input aria-label={ariaLabel} />;
};

export { MaskedInput };
